howspace.emails = (() => {
    'use strict';

    let goBackToStep = 0;

    /**
     *
     * @param {*} modal
     * @param {*} stepNumber
     * @param {*} btn
     */
    const showStep = (modal, stepNumber, btn) => {
        let emailbatch = modal.data('emailbatch');
        const step = modal.find('.steps-bar .step').eq(stepNumber - 1);

        // Remove current aria-current attrs
        modal.find('.steps-bar .step[aria-current="step"]').removeAttr('aria-current');
        step.attr('aria-current', 'step');

        const readyFn = function () {
            let setAsDone = true;

            if (stepNumber === 1) {
                modal.find('.previous-step-btn:not(.notransition)').addClass('d-none');
            } else {
                modal.find('.previous-step-btn:hidden, .next-step-btn:hidden').removeClass('d-none');
            }

            if (stepNumber === 1 && typeof emailbatch.id === 'undefined') {
                modal.find('.modal-header button[data-close-modal="true"]').removeClass('tooltip').dataAndAttr('title', '');
            } else if (modal.hasClass('new-email')) {
                modal.find('.modal-header button[data-close-modal="true"]').addClass('tooltip').dataAndAttr('title', howspace.translate('sendemails_close_and_save_as_draft'));
            }

            modal.find('.next-step-btn:hidden').show();
            modal.find('.start-sending-emails-btn:visible').hide();
            modal.find('.schedule-emails-btn:visible').hide();

            if (step.data('type') === 'preview') {
                const previewContent = modal.find('#preview-content');
                previewContent.html('<div class="howspace-loader howspace-lister-loader medium"></div>');
                let url = real.baseUri + '/emails/' + emailbatch.id + '/send-emails-preview?is_new_email=' + (modal.hasClass('new-email') ? 'true' : 'false');
                const currentPageId = real.dom.$body.data('page-id');
                if (currentPageId) {
                    url += '&current_page_id=' + currentPageId;
                }
                real.ajax.html(url, {
                    type: 'GET',
                    success: response => {
                        previewContent.html(response);
                        howspace.components.init(previewContent);
                    },
                    error: () => {
                        const error = '<div class="alert alert-danger">' + howspace.translate('sendemails_sending_error') + '</div>';
                        previewContent.html(error);
                    }
                });

                modal.find('.next-step-btn').hide();

                if (modal.find('#send-emails-time-radio-later').prop('checked')) {
                    modal.find('.start-sending-emails-btn').hide();
                    modal.find('.schedule-emails-btn').show();
                } else {
                    modal.find('.start-sending-emails-btn').show();
                    modal.find('.schedule-emails-btn').hide();
                }
            }

            const currentActive = modal.find('.steps-bar .step.active');
            currentActive.removeClass('active').addClass('done');
            currentActive.find('.step-icon-active').addClass('d-none');
            currentActive.find('.step-icon-inactive').addClass('d-none');
            currentActive.find('.step-icon-done').removeClass('d-none');

            modal.find('.steps-bar .step').each(function (i, loopStep) {
                if (loopStep === step[0]) {
                    $(step).removeClass('done').addClass('active');
                    $(step).find('.step-icon-active').removeClass('d-none');
                    $(step).find('.step-icon-inactive').addClass('d-none');
                    $(step).find('.step-icon-done').addClass('d-none');

                    setAsDone = false;

                    const visibleContent = modal.find('.process-content:visible');
                    const hiddenContent = $(modal.find('.process-content').get(i));

                    const aniProps = {
                        height: hiddenContent.outerHeight(),
                        opacity: 0
                    }
                    const aniDuration = howspace.getAnimationDuration(modal, '--howspace-animation-150');
                    howspace.animate(visibleContent, aniProps, aniDuration, () => {
                        howspace.animate(hiddenContent, 'slideDown', aniDuration, () => {
                            visibleContent.removeAttr('style').addClass('d-none');
                            real.input.focus(hiddenContent.find('input').first());
                            hiddenContent.removeAttr('style').removeClass('d-none');
                        });
                    });
                } else if (setAsDone) {
                    $(loopStep).addClass('done');
                }
            });
        };

        if (step.length > 0) {
            real.button.loading(btn);
            const payload = getDataPayload(modal);
            const callback = () => {
                real.button.reset(btn);
                readyFn();
            };
            saveEmailBatch(modal, payload, callback);
        } else {
            readyFn();
        }
    };

    /**
     *
     * @param {*} modal
     * @returns
     */
    const getDataPayload = (modal) => {
        let emailbatch = modal.data('emailbatch');
        const visibleContent = modal.find('.process-content:visible');
        let dataPayload = real.form.getDataPayload(visibleContent);

        if (modal.data('business-rule')) {
            dataPayload.business_rule = modal.data('business-rule');
        }

        if (modal.data('send-email-from-widget')) {
            dataPayload.widget = {
                oid: modal.data('send-email-from-widget').oid,
                type: modal.data('send-email-from-widget').type
            }
        }

        if (modal.data('default-email-type')) {
            dataPayload.default_email_type = modal.data('default-email-type');
        }

        // On the message step the form already holds the template's subject and message, maybe edited.
        const emailTemplateContent = modal.data('email-template-content');
        if (emailTemplateContent && !visibleContent.is('#write-the-message-content')) {
            dataPayload.subject = emailTemplateContent.subject;
            dataPayload.message_html = emailTemplateContent.message_html;
            dataPayload.email_template_name = emailTemplateContent.email_template_name;
        }

        if (visibleContent.is('#check-sender-content')) {
            dataPayload.completed_steps = Math.max(1, emailbatch ? emailbatch.completed_steps : 0);
        } else if (visibleContent.is('#choose-recipients-content')) {
            let filters = [];
            if (dataPayload['filter_group'] === 'all-users') {
                // no filters, target all users
            } else if (dataPayload['filter_group'] === 'selected-users') {
                filters = dataPayload.selected_users?.map(userId => `user:${userId}`) || [];
            } else if (dataPayload['filter_group'] === 'filtered-users') {
                const filterElem = visibleContent.find('.howspace-user-filter-picker');
                filters = howspace.components.userFilterPicker.getFilter(filterElem);
            } else if (dataPayload['filter_group'] === 'participants-only') {
                // filters intentionally left empty — the backend resolves participants-only
                // via the role registry using the filter_group value alone
            }

            dataPayload.filters = filters;
            // Remove unneeded properties from dataPayload
            delete dataPayload.selected_users;
            delete dataPayload.users;

            dataPayload.completed_steps = Math.max(2, emailbatch ? emailbatch.completed_steps : 0);

        } else if (visibleContent.is('#write-the-message-content')) {
            dataPayload.completed_steps = Math.max(3, emailbatch ? emailbatch.completed_steps : 0);
            if (modal.find('#send-emails-link-page-radio-landing-page').prop('checked')) {
                dataPayload.login_link_page = null;
            }

            switch (dataPayload.page) {
                case 'current':
                    dataPayload.login_link_path = '/';
                    dataPayload.login_link_page = modal.data('current-page-id');
                    break;

                case 'landing':
                    dataPayload.login_link_path = '/';
                    dataPayload.login_link_page = modal.data('default-landing-page-id');
                    break;

                case 'my-certificates':
                    dataPayload.login_link_page = null;
                    dataPayload.login_link_path = '/manager/my-profile?expand=certificate';
                    break;

                default:
                    dataPayload.login_link_path = '/';
                    dataPayload.login_link_page = dataPayload.page;
                    break;
            }
        } else if (visibleContent.is('#choose-send-time-content')) {
            dataPayload.completed_steps = Math.max(4, emailbatch ? emailbatch.completed_steps : 0);
            if (!modal.find('#send-emails-time-radio-later').prop('checked')) {
                dataPayload.do_not_deliver_before_timestamp = null;
                dataPayload.state = 'draft';
            }
        }
        delete dataPayload.page;

        return dataPayload;
    };

    /**
     *
     * @param {*} modal
     * @param {*} emailbatch
     */
    const updateEmailBatchData = (modal, emailbatch) => {
        modal.dataAndAttr('emailbatch-id', emailbatch.id);
        modal.data('emailbatch', emailbatch);
    };

    /**
     *
     * @param {*} modal
     * @param {*} dataPayload
     * @param {*} readyFn
     */
    const saveEmailBatch = (modal, dataPayload, readyFn) => {
        let url = real.baseUri + '/api/emailbatches';
        let successFn = (response) => {
            // The template content is stored now, and later saves must not overwrite edits made on the message step.
            // removeData() alone would leave the data attribute, which .data() reads again.
            modal.removeData('email-template-content').removeAttr('data-email-template-content');
            updateEmailBatchData(modal, response.emailbatch);
            updateRecipientsCount(modal);

            const isNewEmail = modal.hasClass('new-email') ? 'true' : 'false';
            const showRecipientsBtn = modal.find('#choose-recipients-content .show-recipients-btn');
            if (showRecipientsBtn.length > 0) {
                const modalData = showRecipientsBtn.data('modal');
                modalData.url = `${real.baseUri}/emails/${response.emailbatch.id}/show-recipients-info-modal?allow_select=true&is_new_email=${isNewEmail}`;
                showRecipientsBtn.dataAndAttr('modal', modalData);
            }

            const usePreviousEmailsBtn = modal.find('#write-the-message-content .choose-previously-sent-email-as-draft-btn');
            if (usePreviousEmailsBtn.length > 0) {
                const usePreviousEmailsModalData = usePreviousEmailsBtn.data('modal');
                usePreviousEmailsModalData.url = `${real.baseUri}/emails/${response.emailbatch.id}/use-previous-emails-as-draft-modal?is_new_email=${isNewEmail}`;
                usePreviousEmailsBtn.dataAndAttr('modal', usePreviousEmailsModalData);
            }
        };

        if (modal.data('emailbatch-id')) {
            url = real.baseUri + '/api/emailbatch/' + modal.data('emailbatch-id');
        }

        real.ajax.json(url, {
            type: 'POST',
            data: JSON.stringify(dataPayload),
            success: response => {
                successFn(response);
                if (typeof readyFn === 'function') {
                    readyFn();
                }
            },
            logError: response => {
                let logError = true;

                if (response.status === 403) {
                    logError = false;
                }

                real.ajax.loopErrors(response, function (error) {
                    if (error.code === 4002 &&
                        (error.key === 'invalid_property_value_from_name'
                            || error.key === 'invalid_property_value_from_email_local_part'
                            || error.key === 'invalid_property_value_reply_to_email_address'
                            || error.key === 'invalid_property_value_subject'
                        )) {
                        logError = false;
                    }
                });

                return logError;
            },
            showErrorNotification: false,
            error: response => {
                real.ajax.loopErrors(response, function (error) {
                    if (error.code === 4002) {
                        if (error.key === 'invalid_property_value_from_name') {
                            modal.find('#send-emails-from-name').addClass('is-invalid');
                        }
                        if (error.key === 'invalid_property_value_from_email_local_part') {
                            modal.find('#send-emails-from-email-local-part').addClass('is-invalid');
                        }
                        if (error.key === 'invalid_property_value_reply_to_email_address') {
                            modal.find('#send-emails-reply-to').addClass('is-invalid');
                        }
                        if (error.key === 'invalid_property_value_subject') {
                            modal.find('#send-emails-subject').addClass('is-invalid');
                        }
                    }
                });

                let btn = modal.find('.step.loading.disabled, .btn.loading.disabled');
                if (btn.length > 0) {
                    real.button.reset(btn, modal.find('.modal-footer'));
                }
            }
        });
    };

    /**
     *
     * @param {*} modal
     */
    const updateRecipientsCount = (modal) => {
        const btn = modal.find('#choose-recipients-content .show-recipients-btn');
        const emailbatch = modal.data('emailbatch');
        const sendNowWrapper = modal.find('.send-now-label');
        const sendNowRadio = sendNowWrapper.find('#send-emails-time-radio-now');
        const sendLaterWrapper = modal.find('.send-later-label');
        const sendLaterRadio = sendLaterWrapper.find('#send-emails-time-radio-later');

        let url = real.baseUri + '/emails/' + emailbatch.id + '/recipients';
        const currentPageId = real.dom.$body.data('page-id');
        if (currentPageId) {
            url += '?current_page_id=' + currentPageId;
        }
        real.ajax.json(url, {
            type: 'GET',
            data: {
                'limit': 1
            },
            success: response => {
                let count = response.total_items - emailbatch.excluded_users.length;

                if (count < 0) {
                    count = 0;
                }

                btn.text(howspace.translate('sendemails_show_recipients') + ' (' + count + ')');
                btn.prop('disabled', count === 0);
                modal.find('.start-sending-emails-btn').prop('disabled', count === 0);

                if (count === 0) {
                    // Disable the option to send now
                    sendNowRadio.prop('checked', false).addClass('disabled').prop('disabled', true);
                    sendNowWrapper.addClass('disabled');
                    sendLaterRadio.prop('checked', true).removeClass('disabled').prop('disabled', false).trigger('change');
                    sendLaterWrapper.removeClass('disabled');
                } else {
                    // Enable the option to send now
                    sendNowRadio.removeClass('disabled').prop('disabled', false);
                    sendNowWrapper.removeClass('disabled');
                }
            }
        });
    };

    /**
     *
     * @param {*} modal
     */
    const sendEmails = (modal) => {
        const emailbatch = modal.data('emailbatch');
        const dataPayload = getDataPayload(modal);
        dataPayload.state = 'send';
        dataPayload.completed_steps = 5;

        saveEmailBatch(modal, dataPayload, () => {
            let notificationText = '';
            if (emailbatch.do_not_deliver_before_timestamp === null) {
                notificationText = howspace.translate('sendemails_send_emails_now');
            } else {
                notificationText = howspace.translate('sendemails_emails_scheduled_on_date', {
                    date: modal.find('#send-emails-later-date').val(),
                });
            }

            howspace.components.modal.close(modal);

            real.notification.show(notificationText, 'success');
        });
    };

    const updateRecipientFilter = (e) => {
        const modal = $(e.currentTarget).closest('.modal');

        const dataPayload = getDataPayload(modal);
        if (!dataPayload) {
            return;
        }

        dataPayload.excluded_users = []; // reset excluded users when filter changes
        saveEmailBatch(modal, dataPayload);
    };

    /**
     *
     * @param {*} modal
     */
    const initSendEmailModal = (modal) => {
        modal = $(modal);

        // Clearing the template brings back the message a new email starts with. Nothing is saved until Next.
        modal.on('click', '.clear-email-template-btn', () => {
            const content = modal.find('#write-the-message-content');
            content.find('#send-emails-subject').val(content.data('default-subject'));
            howspace.components.textEditor.setContent(content.find('#send-emails-message-html'), content.data('default-message-html'));
            content.find('input[name="email_template_name"]').val('');
            content.find('.email-template-in-use').addClass('d-none');
            content.find('.write-new-or-use-draft').removeClass('d-none');
        });

        const userBatchRules = [
            'userbatch_created_users',
            'userbatch_updated_users',
            'userbatch_created_and_updated_users',
        ];
        if (userBatchRules.includes(modal.data('business-rule')?.rule)) {
            // Skip recipient selection step for user batch rules. Recipients are resolved server-side from the batch context.
            showStep(modal, 3, modal.find('.next-step-btn'));
        }

        modal.find('.steps-bar .step.done').each(function (i, step) {
            $(step).find('.step-icon-active').addClass('d-none');
            $(step).find('.step-icon-inactive').addClass('d-none');
            $(step).find('.step-icon-done').removeClass('d-none');
        });

        modal.find('.steps-bar').on('click', '.step.done:not(.disabled)', function (e) {
            showStep(modal, modal.find('.steps-bar .step').index(this) + 1, $(this));
        });

        modal.find('.modal-footer').on('click', '.previous-step-btn:not(.disabled)', e => {
            const stepNumber = modal.find('.steps-bar .step').index(modal.find('.steps-bar .step.active')[0]);
            showStep(modal, stepNumber, $(e.target));
        });

        modal.find('.modal-footer').on('click', '.next-step-btn:not(.disabled)', e => {
            const stepNumber = modal.find('.steps-bar .step').index(modal.find('.steps-bar .step.active')[0]) + 2;
            showStep(modal, stepNumber, $(e.target));
        });

        modal.find('.modal-footer').on('click', '.cancel-btn', () => {
            const emailbatch = modal.data('emailbatch');
            if (emailbatch?.id && emailbatch?.state === 'draft') {
                real.ajax.json(real.baseUri + '/api/emailbatch/' + emailbatch.id, {
                    type: 'DELETE'
                });
            } else {
                howspace.components.modal.close(modal);
            }
        });

        modal.find('.start-sending-emails-btn, .schedule-emails-btn').on('click', () => {
            sendEmails(modal);
        });

        modal.find('#send-emails-from-name').on('input', real.input.validateEmailDisplayName);
        modal.find('#send-emails-from-name').on('input', e => {
            $(e.target).removeClass('is-invalid');
        });

        modal.find('#send-emails-from-email-local-part').on('input', real.input.validateEmailLocal);
        modal.find('#send-emails-from-email-local-part').on('blur', real.input.validateEmailLocalBlur);
        modal.find('#send-emails-from-email-local-part').on('input', e => {
            $(e.target).removeClass('is-invalid');
        });

        modal.find('#send-emails-reply-to').on('input', real.input.validateEmail);
        modal.find('#send-emails-reply-to').on('blur', real.input.validateEmailBlur);
        modal.find('#send-emails-reply-to').on('input', e => {
            $(e.target).removeClass('is-invalid');
        });

        modal.on(howspace.components.userFilterPicker.FILTER_CHANGED, (e) => {
            howspace.form.enable(modal.find('.howspace-user-filter-picker'));
            updateRecipientFilter(e);
        });

        modal.find('#choose-recipients-content').on('change', 'input.filter-radio', updateRecipientFilter);
        modal.find('#choose-recipients-content').on(howspace.components.collapse.COLLAPSED, updateRecipientFilter);
        modal.find('#choose-recipients-content').on(howspace.components.collapse.EXPANDED, updateRecipientFilter);
        modal.find('#choose-recipients-content').on(howspace.components.userPicker.USER_ADDED, updateRecipientFilter);
        modal.find('#choose-recipients-content').on(howspace.components.userPicker.USER_REMOVED, updateRecipientFilter);

        modal.find('#choose-recipients-content').on('click', '.show-recipients-btn', () => {
            goBackToStep = 2;
        });

        modal.find('#preview-content').on('click', '.show-recipients-btn', () => {
            goBackToStep = 5;
        });

        modal.find('#write-the-message-content').on('click', '.choose-previously-sent-email-as-draft-btn', () => {
            goBackToStep = modal.find('.steps-bar .step').length === 5 ? 3 : 2;
        });

        if (goBackToStep !== 0) {
            const showChooseRecipientsStepInteral = setInterval(() => {
                showStep(modal, goBackToStep, modal.find('.next-step-btn:not(.disabled)'));
                clearInterval(showChooseRecipientsStepInteral);
                goBackToStep = 0;
            }, 100);
        }
    };

    const initShowRecipientsInfoModal = (modal) => {
        modal = $(modal);

        modal.find('.save-recipients-btn').on('click', function () {
            const excluded_users = [];
            modal.find('.recipient-selected-checkbox:not(:checked)').each(function () {
                excluded_users.push($(this).closest('tr').data('user-id'));
            });
            const url = real.baseUri + '/api/emailbatch/' + modal.data('emailbatch-id');
            real.ajax.json(url, {
                type: 'POST',
                data: JSON.stringify({
                    'excluded_users': excluded_users
                }),
                success: () => {
                    modal.find('.back-btn').trigger('click');
                }
            });
        });

        modal.find('.modal-header .btn[data-close-modal="true"], .modal-footer .cancel-btn').on('click', () => {
            goBackToStep = 0;
        });
    }

    const initUsePreviousEmailsModal = (modal) => {
        modal = $(modal);

        modal.find('#card-use-previous-emails-as-draft').on('change', '.used-as-draft-checkbox', e => {
            const checkbox = $(e.target);
            modal.find('.used-as-draft-checkbox').not(checkbox).prop('checked', false);
            // There is nothing to use until an email or a template is picked.
            modal.find('.use-as-draft-btn').prop('disabled', !checkbox.prop('checked'));
        });

        modal.find('.modal-footer').on('click', '.use-as-draft-btn', e => {
            const btn = $(e.target);
            const pickedRow = modal.find('.used-as-draft-checkbox:checked').closest('tr');
            const emailBatchId = pickedRow.filter('.emailbatch-row').data('emailbatch-id');
            const emailTemplateId = pickedRow.filter('.email-template-row').data('email-template-id');

            // A template is fetched with its sender and workspace tags already filled in for this workspace. It only
            // has a subject and a message, so the fields it lacks are left out of the payload and stay as they are.
            let sourceUrl;
            let sourceKey;
            if (emailBatchId) {
                sourceUrl = real.baseUri + '/api/emailbatch/' + emailBatchId;
                sourceKey = 'emailbatch';
            } else if (emailTemplateId) {
                sourceUrl = real.baseUri + '/emails/template-content?template=' + encodeURIComponent(emailTemplateId);
                sourceKey = 'emailtemplate';
            } else {
                return;
            }

            real.button.loading(btn, modal);
            real.ajax.json(sourceUrl, {
                type: 'GET',
                success: (response) => {
                    const source = response[sourceKey];
                    const url = real.baseUri + '/api/emailbatch/' + modal.data('emailbatch-id');
                    real.ajax.json(url, {
                        type: 'POST',
                        data: JSON.stringify({
                            'completed_steps': modal.data('completed-steps') < 3 ? 3 : modal.data('completed-steps'),
                            'message_html': source.message_html,
                            'sender_html': source.sender_html,
                            'subject': source.subject,
                            'login_button_text': source.login_button_text,
                            'include_sender_image': source.include_sender_image,
                            // A previous email clears the template the draft may have been started from.
                            'email_template_name': sourceKey === 'emailtemplate' ? source.email_template_name : '',
                        }),
                        success: () => {
                            real.button.reset(btn, modal);
                            modal.find('.back-btn').trigger('click');
                        }
                    });
                },
                error: () => {
                    real.button.reset(btn, modal);
                }
            });
        });

        modal.find('.modal-footer').on('click', '.use-as-draft-btn', () => {
            goBackToStep = 3;
        });

        modal.find('.modal-header .btn[data-close-modal="true"], .modal-footer .cancel-btn').on('click', () => {
            goBackToStep = 0;
        });
    }

    real.events.on('emailbatch:deleted', notification => {
        const modal = $('.modal[data-emailbatch-id="' + notification.object.emailbatch.id + '"]');
        if (modal.length > 0) {
            howspace.components.modal.close(modal);
        }
    });

    return {
        initSendEmailModal: initSendEmailModal,
        initShowRecipientsInfoModal: initShowRecipientsInfoModal,
        initUsePreviousEmailsModal: initUsePreviousEmailsModal
    };
})();
